import { MessageCircle } from "lucide-react";
import { waLink } from "../../lib/wa";

export const FloatingWA = () => (
    <a
        href={waLink()}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-wa-cta"
        aria-label="Chat WhatsApp"
        className="fixed bottom-5 left-5 z-40 inline-flex items-center gap-3 bg-jws-secondary text-jws-bg pl-4 pr-5 py-3 rounded-full shadow-lg hover:bg-jws-primary transition-colors"
    >
        <span className="relative grid place-items-center h-8 w-8 rounded-full bg-jws-ochre text-jws-text">
            <MessageCircle className="h-4 w-4" />
            <span className="absolute -top-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-emerald-500 ring-2 ring-jws-secondary" />
        </span>
        <span className="hidden sm:inline font-medium text-sm">
            Chat WhatsApp
        </span>
    </a>
);
